import { MrbBaseRouteStore } from "mrb/core";
import { DeviceService, UserSettingsService } from "common/services";

class DeviceListRouteStore extends MrbBaseRouteStore {
    constructor(rootStore) {
        super(rootStore);

        this.service = this.rootStore.createApplicationService(DeviceService);
        this.userSettingsService = this.rootStore.createApplicationService(UserSettingsService);
    }

    async findUserDevices(params) {
        const response = await this.service.findUserDeviceForAuthenticatedUser(params);
        return response.data;
    }

    deleteUserDevice(resource) {
        return this.rootStore.userDeviceStore.deleteUserDevice(resource);
    }

    async getCertifiedModes() {
        const response = await this.userSettingsService.getCertifiedMode();
        return response.data;
    }

    async updateCertifiedMode(certifiedModeId, whitelistMode) {
        const response = await this.userSettingsService.updateCertifiedMode(certifiedModeId, whitelistMode);
        return response.data;
    }
}

export default DeviceListRouteStore;
